import { LOGIN, LOGOUT } from "../actions/auth.actions";

const defaultState = {
  errors: [],
  loggedIn: false,
  token: null,
  profile_id: null,
  user_id: null
};

const authReducer = (state = defaultState, action) => {
  switch (action.type) {
    case `${LOGOUT}_SUCCEEDED`:
      return {
        ...state,
        loggedIn: false,
        profile_id: null,
        token: null
      };

    case `${LOGIN}_PENDING`:
      return { ...defaultState };

    case `${LOGIN}_SUCCEEDED`:
      return {
        ...state,
        errors: {},
        token: action.payload.data.token,
        profile_id: action.payload.data.profile_id,
        user_id: action.payload.data.user_id,
        loggedIn: true
      };

    case `${LOGIN}_FAILED`:
      let errors = { error: [] };

      if (action.payload.locked_out) {
        errors.error.push(
          "You have exceeded the maximum login attempts your account has been locked for 2 hours."
        );
      } else {
        errors.error.push(
          "Your username and password didn't match. Please try again."
        );
      }

      console.log("action.payload", action.payload);

      return { ...state, errors };

    default:
      return state;
  }
};

export default authReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/auth.reducer.js